// HACKATHON: API hooks - UPDATED with siscomex and selic
import { useState, useEffect } from 'react';

const API_BASE = '/api/go82/api';
const API_BASE_PYTHON = '/api/py82/api'; // Python endpoints

// Generic fetch hook - reusable
export const useAPIData = (endpoint, interval = 30000) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE}${endpoint}`);
        const json = await res.json();
        setData(json);
        setLoading(false);
      } catch (err) {
        console.error(`Error fetching ${endpoint}:`, err);
        setLoading(false);
      }
    };

    fetchData();
    const timer = setInterval(fetchData, interval);
    return () => clearInterval(timer);
  }, [endpoint, interval]);

  return { data, loading };
};

// Generic fetch for Python API
export const usePythonAPIData = (endpoint, interval = 30000) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE_PYTHON}${endpoint}`);
        const json = await res.json();
        setData(json);
        setLoading(false);
      } catch (err) {
        console.error(`Error fetching ${endpoint}:`, err);
        setLoading(false);
      }
    };

    fetchData();
    const timer = setInterval(fetchData, interval);
    return () => clearInterval(timer);
  }, [endpoint, interval]);

  return { data, loading };
};

// Go API endpoints
export const useCommodities = () => useAPIData('/commodities');
export const useCurrencies = () => useAPIData('/currencies');
export const useIndices = () => useAPIData('/indices');

// Python API endpoints

export const useRR_News = () => usePythonAPIData('/news');
export const useSiscomex = () => usePythonAPIData('/siscomex');
export const useSelic = () => usePythonAPIData('/selic');
